import actions from './actions'

export default function ClinPaymentTypesReducer(state = { loading: false }, action) {
  switch (action.type) {
    case actions.REQUESTING:
      return {
        ...state,
        loading: true,
        editing: null,
        saveSuccess: false,
      }
    case actions.LIST_CLINPAYMENTTYPE:
      return {
        ...state,
        result: action.result,
        loading: false,
        saveSuccess: false,
      }
    case actions.EDIT_CLINPAYMENTTYPE:
      return {
        ...state,
        editing: action.result,
        loading: false,
        saveSuccess: false,
      }
    case actions.RESET_CLINPAYMENTTYPE:
      return {
        ...state,
        editing: null,
        loading: false,
        saveSuccess: false,
      }
    case actions.NEW_CLINPAYMENTTYPE:
      return {
        ...state,
        editing: { clinPaymentTypeID: 0 },
        loading: false,
        saveSuccess: false,
      }
    case actions.SAVE_CLINPAYMENTTYPE_RECIEVED ||
      actions.DELETE_CLINPAYMENTTYPE_RECIEVED:
      return {
        ...state,
        editing: { clinPaymentTypeID: 0 },
        loading: false,
        saveSuccess: true, // mark
      }
    case actions.RESPONSE_ERROR:
      return {
        ...state,
        loading: false,
        error: true,
        saveSuccess: false,
        message: action.message,
      }
    default:
      return state
  }
}
